import { Box, Button, Flex, Image, InputGroup, FormControl, FormLabel, Text } from "@chakra-ui/react";
import React from "react";
import { DatePicker, Modal } from "antd";
import { Icons } from "../../Assets/icons";
import { MEETING_REQUEST_STATUS } from "../../Constants/data";
import { disabledDate } from "../../Utils/Validator";
import dayjs from "dayjs";
import ConfirmationModal from "../../Components/Modals/ConfirmationModal";
import RelevanceModal from "../../Components/Modals/RelevanceModal";
import RelevanceModalBuyer from "../../Components/Modals/RelevanceModalBuyer";
import FeedbackModal from "Components/Modals/FeedbackModal";

// Claude: extracted from MeetingList.tsx 23-03-2026
interface Props {
  user: any;
  meetings: any[];
  meetsStatusArray: any[];
  // Change confirmation modal
  changeConfirmationModal: boolean;
  handleCloseChangeConfirmationModal: () => void;
  selectedChangeMeeting: any;
  setSelectedMeet: (m: any) => void;
  handleCalendarModalOpen: () => void;
  setType: (t: "new" | "edit") => void;
  error: (msg: string) => void;
  // Feedback modal
  feedbackModal: boolean;
  handleCloseFeedbackModal: () => void;
  selectedFeedbackMeeting: any;
  handleFeedbackYes: () => void;
  handleFeedbackNo: () => void;
  // Relevance modal
  releModal: boolean;
  handleCloseRelevanceModal: () => void;
  relevanceData: any;
  buyerRelevanceData: any;
  reloadRelevanceData: () => void;
  // Meet time conflict confirm modal
  meetTimeConfirm: boolean;
  handleCloseMeetTimeConfirmModal: () => void;
  activeMeetingItem: any;
  handleUpdate: (id: string, data: any) => void;
  setActiveMeetingItem: (v: any) => void;
  selectedMeet: any;
  changeMeetingRequestStatus: () => void;
  // Meet cancel confirm modal
  meetConfirm: boolean;
  handleCloseMeetConfirmModal: () => void;
  activeId: string;
  // Status select modal
  isModalOpen: boolean;
  handleModalClose: () => void;
  status: string;
  setStatus: (s: string) => void;
  meetingCounts: any;
  // Calendar (new/edit meeting request) modal
  isCalendarModalOpen: boolean;
  handleCalendarModalClose: () => void;
  date: string;
  setDate: (d: string) => void;
  time: string;
  setTime: (t: string) => void;
  handleSubmitEditOrNew: () => void;
}

const MeetingListModals = ({
  user, meetings, meetsStatusArray,
  changeConfirmationModal, handleCloseChangeConfirmationModal, selectedChangeMeeting,
  setSelectedMeet, handleCalendarModalOpen, setType, error,
  feedbackModal, handleCloseFeedbackModal, selectedFeedbackMeeting,
  handleFeedbackYes, handleFeedbackNo,
  releModal, handleCloseRelevanceModal, relevanceData, buyerRelevanceData, reloadRelevanceData,
  meetTimeConfirm, handleCloseMeetTimeConfirmModal, activeMeetingItem,
  handleUpdate, setActiveMeetingItem, selectedMeet, changeMeetingRequestStatus,
  meetConfirm, handleCloseMeetConfirmModal, activeId,
  isModalOpen, handleModalClose, status, setStatus, meetingCounts,
  isCalendarModalOpen, handleCalendarModalClose, date, setDate, time, setTime,
  handleSubmitEditOrNew,
}: Props) => (
  <>
    {/* Change confirmation modal */}
    <Modal closeIcon={null} footer={null} title={null}
      open={changeConfirmationModal} onOk={handleCloseChangeConfirmationModal} onCancel={handleCloseChangeConfirmationModal}>
      <ConfirmationModal
        handleCloseModal={handleCloseChangeConfirmationModal}
        handleSubmit={() => {
          if (selectedChangeMeeting) {
            const finalMeet = meetings.find((meet: any) => meet._id === selectedChangeMeeting._id);
            if (finalMeet) {
              setSelectedMeet(finalMeet);
              handleCalendarModalOpen();
              setType("edit");
            } else {
              error("Unable to change meeting!");
            }
          }
          handleCloseChangeConfirmationModal();
        }}
        title={"Confirm Change"}
        message={"Previous meeting slot will no longer be valid. Continue?"}
        confirmBtnText={"Yes"}
        rejectButtonText={"No"}
      />
    </Modal>

    {/* Feedback modal */}
    <Modal closeIcon={null} footer={null} title={null}
      open={feedbackModal} onOk={handleCloseFeedbackModal} onCancel={handleCloseFeedbackModal}>
      <FeedbackModal
        buyerCompanyName={
          // Other party's company: if I am the responder, other party is requester
          user.user === selectedFeedbackMeeting.responderId
            ? selectedFeedbackMeeting.requesterCompany
            : selectedFeedbackMeeting.responderCompany
        }
        onClose={handleCloseFeedbackModal}
        onYesClick={handleFeedbackYes}
        onNoClick={handleFeedbackNo}
      />
    </Modal>

    {/* Relevance modal — conditionally renders seller or buyer variant based on user role */}
    <Modal closeIcon={null} footer={null} title={null}
      open={releModal} onOk={handleCloseRelevanceModal} onCancel={handleCloseRelevanceModal}>
      {user.role === "Seller" ? (
        // Seller prequalifying buyers
        <RelevanceModal
          data={relevanceData}
          relaodData={reloadRelevanceData}
          handleCloseModal={handleCloseRelevanceModal}
        />
      ) : (
        // Buyer prequalifying sellers
        <RelevanceModalBuyer
          data={buyerRelevanceData}
          relaodData={reloadRelevanceData}
          handleCloseModal={handleCloseRelevanceModal}
        />
      )}
    </Modal>

    {/* Meet time conflict confirm modal */}
    <Modal closeIcon={null} footer={null} title={null}
      open={meetTimeConfirm} onOk={handleCloseMeetTimeConfirmModal} onCancel={handleCloseMeetTimeConfirmModal}>
      <ConfirmationModal
        handleCloseModal={handleCloseMeetTimeConfirmModal}
        handleSubmit={() => {
          if (Object.keys(activeMeetingItem).length > 0) {
            // Accept button was clicked
            handleUpdate(activeMeetingItem._id, { response: MEETING_REQUEST_STATUS.CONFIRM });
            handleCloseMeetTimeConfirmModal();
            setActiveMeetingItem({});
          } else if (Object.keys(selectedMeet).length > 0) {
            // Change button was clicked
            changeMeetingRequestStatus();
            handleCloseMeetTimeConfirmModal();
          } else {
            error("Unable to confirm meeting!");
          }
        }}
        title={" "}
        message={"There is an other confirmed meeting within 30 minutes of this meeting. Continue ?"}
        confirmBtnText={"Yes, Confirm this meeting"}
        rejectButtonText={"No"}
      />
    </Modal>

    {/* Meet cancel confirm modal */}
    <Modal closeIcon={null} footer={null} title={null}
      open={meetConfirm} onOk={handleCloseMeetConfirmModal} onCancel={handleCloseMeetConfirmModal}>
      <ConfirmationModal
        handleCloseModal={handleCloseMeetConfirmModal}
        handleSubmit={() => {
          handleUpdate(activeId, { response: MEETING_REQUEST_STATUS.CANCELLED });
        }}
        title={"Confirm cancellation"}
        message={"The other party would be notified that the meeting is cancelled. Continue ?"}
        confirmBtnText={"Yes, Cancel"}
        rejectButtonText={"No"}
      />
    </Modal>

    {/* Status select modal */}
    <Modal footer={null} title={""} onOk={handleModalClose} onCancel={handleModalClose}
      open={isModalOpen} closeIcon={null}>
      <Box w={"100%"} h={"100%"}>
        <Box position={"relative"} display={"flex"} justifyContent={"center"} alignItems={"center"} h={"60px"}>
          <Text fontSize={"20px"} fontWeight={700} textAlign={"center"} color={"black"}>
            Select Status
          </Text>
          <Image onClick={handleModalClose} position={"absolute"} src={Icons.cross} left={0} top={0} />
        </Box>
        {/* Claude: scrollable status list 25-03-2026 */}
        <Flex direction={"column"} gap={4} maxH="60vh" overflowY="auto">
          {meetsStatusArray?.map((meetStatus, index) => (
            <Button
              key={index}
              flex={1} w={"100%"} p={0} py={3}
              bg={meetStatus.status == status ? meetStatus.bg : "white"}
              color={meetStatus.status == status ? meetStatus.color : "black"}
              _hover={{ bg: meetStatus.bg, color: meetStatus.color }}
              display={"flex"} justifyContent={"start"} gap={2} px={3}
              onClick={() => { setStatus(meetStatus.status); handleModalClose(); }}
            >
              {meetStatus.label}({meetingCounts[meetStatus.status]})
            </Button>
          ))}
        </Flex>
      </Box>
    </Modal>

    {/* Calendar modal — new meeting request or propose alternate date */}
    <Modal footer={null} title={""} onOk={handleCalendarModalClose} onCancel={handleCalendarModalClose}
      open={isCalendarModalOpen} closeIcon={null}>
      <Box h={"100%"} w={"100%"}>
        <Box position={"relative"} display={"flex"} justifyContent={"center"} alignItems={"center"} h={"60px"}>
          <Image onClick={handleCalendarModalClose} position={"absolute"} src={Icons.cross} left={0} top={0} />
        </Box>
        <Flex direction={"column"} justifyContent={"center"}>
          <Text fontSize={"18px"} fontWeight={"semibold"} mt={3} textAlign={"center"}>
            Meeting request to{" "}
            {/* If I am the requester, I'm sending to the responder; if I am the responder, I reply to the requester */}
            {user.user == selectedMeet.requesterId
              ? selectedMeet?.responderCompany
              : selectedMeet.requesterCompany || "Company Name"}
          </Text>
          <FormControl mt={10}>
            <Text fontSize={"xs"} fontWeight={"light"} fontStyle={"italic"}>
              *Appointments for telephonic/web meetings. Meetings are shown in your timezone.
            </Text>
            <FormLabel>Date</FormLabel>
            <InputGroup>
              <DatePicker
                renderExtraFooter={() => null}
                value={date ? dayjs(date) : null}
                onChange={(time2, dateString) => { setDate(dateString); }}
                disabledDate={disabledDate}
                style={{ width: "100%", height: "50px" }}
                placeholder="Choose Date"
                superNextIcon={null}
                inputReadOnly
                superPrevIcon={null}
                popupClassName="custom-date-picker-meeting-popup"
              />
            </InputGroup>
          </FormControl>
          <FormControl mt={5}>
            <FormLabel>Time</FormLabel>
            <input
              type="time"
              style={{ width: "100%", height: "50px", padding: "0 10px", border: "1px solid #E2E8F0", background: "white" }}
              onChange={(e) => { setTime(e.target.value); }}
              value={time}
            />
          </FormControl>
          <Flex alignItems={"center"} gap={3} mt={"25px"}>
            <Button onClick={handleSubmitEditOrNew} flex={1} size={"md"} p={0} bg={"secondary.light"} color={"secondary.main"}>
              Send
            </Button>
            <Button
              onClick={() => { setTime(""); setDate(""); handleCalendarModalClose(); }}
              flex={1} size={"md"} p={0} bg={"gray.100"} color={"gray.600"}
            >
              Cancel
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Modal>
  </>
);

export default MeetingListModals;
